var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUpload = function SvgUpload(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M20 20.75a.75.75 0 0 0 0-1.5v1.5Zm-16-1.5a.75.75 0 0 0 0 1.5v-1.5Zm8.75-17.249a.75.75 0 0 0-1.5 0h1.5Zm-1.5 14a.75.75 0 0 0 1.5 0h-1.5Zm5.22-8.47a.75.75 0 0 0 1.06-1.06l-1.06 1.06ZM11.999 2l.53-.53a.75.75 0 0 0-1.06 0l.53.53Zm-5.53 4.47a.75.75 0 0 0 1.06 1.061l-1.06-1.06ZM20 19.25H4v1.5h16v-1.5ZM11.25 2.001v14h1.5v-14h-1.5Zm6.28 4.47-5-5.001-1.061 1.06 5 5.001 1.061-1.06ZM11.47 1.47l-5 5 1.06 1.061 5-5-1.06-1.061Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUpload);
export default ForwardRef;